module.exports = __webpack_public_path__ + "img/b1 (5).c9a6341f.png";